export default function SuccessIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 0C8.81782 0 5.76473 1.2646 3.51449 3.51449C1.26448 5.76449 0 8.81753 0 12C0 15.1825 1.2646 18.2353 3.51449 20.4855C5.76449 22.7355 8.81753 24 12 24C15.1825 24 18.2353 22.7354 20.4855 20.4855C22.7355 18.2355 24 15.1825 24 12C23.9965 8.81871 22.7319 5.76798 20.482 3.51803C18.232 1.26803 15.1813 0.00354462 12 0ZM17.5754 9.53886L11.4219 15.6923C11.0608 16.0523 10.4769 16.0523 10.1169 15.6923L6.42462 12C6.21461 11.6296 6.28385 11.1646 6.59308 10.8727C6.90347 10.5808 7.37192 10.5381 7.72963 10.7688L10.7688 13.7723L16.2704 8.3077C16.6281 8.07578 17.0965 8.11847 17.4069 8.4104C17.7162 8.70232 17.7854 9.16847 17.5754 9.53886Z"
        fill="#33897D"/>
    </svg>
  )
}
